import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
export var CallStatusUpdateMessageComponent = function (_React$Component) {
  _inherits(CallStatusUpdateMessageComponent, _React$Component);

  var _super = _createSuper(CallStatusUpdateMessageComponent);

  function CallStatusUpdateMessageComponent(state, props) {
    _classCallCheck(this, CallStatusUpdateMessageComponent);

    return _super.call(this, state, props);
  }

  _createClass(CallStatusUpdateMessageComponent, [{
    key: "render",
    value: function render() {
      return React.createElement("div", null, React.createElement("div", {
        className: 'col-md-10 system-message-callstatus'
      }, React.createElement("p", {
        className: 'system-message-call-updates'
      }, React.createElement("span", {
        className: "system-message-message"
      }, this.props.callStatusUpdateMessage))));
    }
  }]);

  return CallStatusUpdateMessageComponent;
}(React.Component);